import React, { useState, useEffect } from "react";
import NavNewDark from "../NavBar/NavNewDark";
import NavNew from "../NavBar/NavNew";
import FooterNew from "../NavBar/FooterNew";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import base_url from "../../api/bootapi";
import attachmenturl from "../../api/attachmenturl";
import { useDispatch, useSelector } from "react-redux";
import { Collapse, CardBody, Card } from "reactstrap";
import { getTour, selectTour } from "../Reducers/tourSlice";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import { Col, Row, Button } from "reactstrap";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import moment from "moment";
import { Controller, useForm } from "react-hook-form";
import Modal from "react-bootstrap/Modal";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import Swal from "sweetalert2";
import { PaymentInputsWrapper, usePaymentInputs } from "react-payment-inputs";
import images from "react-payment-inputs/images";
import bannerbackground from "../../assets/bannerbackground.jpg";
import { width } from "@mui/system";
import Nav from "../NavBar/Nav";
import GoogleAddressInput from "./GoogleAddressInput";
import NewGoogleAddressInput from "./NewGoogleAddressInput";
import TravelDate from "../TravelComponents/Date";
import NewDate from "./NewDate";

const options = [{
    label: "First",
    value: "First"
},
{
    label: "Business",
    value: "Business"
},
{
    label: "Premium",
    value: "Premium"
},
{
    label: "Economy Class (Cost will be advised)",
    value: "Economy Class"
}


];


const TourTripEnrollmentCopy1 = () => {
    const params = useParams();

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        control,
        setValue,
        watch,
    } = useForm();

    const validateDateFormat = (value) => {
        const ddmmyyyy = /^\d{2}-\d{2}-\d{4}$/; // dd-mm-yyyy
        // const yyyymmdd = /^\d{4}-\d{2}-\d{2}$/; // yyyy-mm-dd

        if (ddmmyyyy.test(value)) {
            return true;
        }

        return "Date must be in mm-dd-yyyy format";
    };

    const {
        wrapperProps,
        getCardImageProps,
        getCardNumberProps,
        getExpiryDateProps,
        getCVCProps,
    } = usePaymentInputs();

    const formData = new FormData();
    const [viewModal, setViewModal] = useState(false);
    const handleViewModal = () => {
        setViewModal(!viewModal);
        reset() // reseting the form
    }


    const [backdropopen, setbackdropopen] = useState(false);
    const [tripData, setTripData] = useState();
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");

    const [country1, setcountry1] = useState("United States");
    const [countryValid1, setcountryValid1] = useState(false);

    const [region1, setregion1] = useState("New York");
    const [region1Valid, setregion1Valid] = useState(false);

    const [country2, setcountry2] = useState("United States");
    const [countryValid2, setcountryValid2] = useState(false);

    const [region2, setregion2] = useState("New York");
    const [region2Valid, setregion2Valid] = useState(false);
    const [advancePayment, setAdvancePayment] = useState(0.00);
    const [zelleAdvancePayment, setZelleAdvancePayment] = useState(0.00);

    const [minAdvance, setminAdvance] = useState(0);
    const [deposit, setDeposit] = useState(0);
    const [depositRequired, setDepositRequired] = useState(false);
    const [minimumDepositError, setMinimumDepositError] = useState(false)
    const [minimumDepositRequired, setMinimumDepositRequired] = useState(false)
    const [enableExtraDeposit, setEnableExtraDeposit] = useState(false);
    const [minimumDeposit, setMinimumDeposit] = useState(0);
    const [totalMinimumDeposit, setTotalMinimumDeposit] = useState(0);
    const [otherAmount, setOtherAmount] = useState(0);
    const [ticketInDeposit, setTicketInDeposit] = useState(false);
    const [insuranceInDeposit, setInsuranceInDeposit] = useState(false);
    const [otherCostInDeposit, setOtherCostInDeposit] = useState(false);
    const [accommodationInDeposit, setAccommodationInDeposit] = useState(false);
    const [singleRoomCostInDeposit, setSingleRoomCostInDeposit] = useState(false);
    const [depositEnabled, setDepositDisabled] = useState(false);

    const [airParticipants, setAirParticipants] = useState(0);
    const [airParticipantStatus, setAirParticipantStatus] = useState(false);
    const [modeStatus, setModeStatus] = useState(false);
    const [nonAirParticipants, setNonAirParticipants] = useState(0);
    const [totalParticipantStatus, setTotalParticipantStatus] = useState(false);

    const [airFarePrice, setAirFarePrice] = useState();
    const [withoutAirFarePrice, setWithoutAirFarePrice] = useState();

    const [tripSeatData, setTripSeatData] = useState([]);
    const [tripSeatData2, setTripSeatData2] = useState([]);

    const [finalParticipants, setFinalParticipants] = useState();
    const [modeOfTour, setModeOfTour] = useState();

    const [paymentMethod, setPaymentMethod] = useState("Cash");

    const [imageData, setImageData] = useState();
    const [tourTitle, setTourTitle] = useState([]);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const allTour = useSelector(selectTour);
    const [sameAsAbove, setSameAsAbove] = useState(false);

    const [f, setf] = useState();
    const location = useLocation();
    const tour_names = location.state?.tour_names || null;
    const [upcomingTourName, setupcomingTourName] = useState();
    const [fullPackage, setFullPackage] = useState(0);
    const [accommodation, setAccommodation] = useState(0);
    const [singleRoomCost, setSingleRoomCost] = useState(0);
    const [insurancePrice, setInsurancePrice] = useState(0);
    const [otherCost, setOtherCost] = useState(0);
    const [otherCostDescription, setOtherCostDescription] = useState(null)
    const [cardError, setCardError] = useState(null);
    const [totalPrice, setTotalPrice] = useState(0);
    const [isPastTour, setIsPastTour] = useState(true);
    const [mobile, setMobile] = useState();
    const [selectedOptions, setSelectedOptions] = useState({
        fullPackage: false,
        accommodation: false,
        insurance: false,
        singleRoomCost: false

    });
    const [selectedCardOptions, setSelectedCardOptions] = useState({
        fullPackage: false,
        accommodation: false,
        insurance: false,
        singleRoomCost: false,

        deposit: true,
    });
    const originalCity = watch("city");
    const originalZip = watch("zip");
    const [totalPricewithoutCharge, settotalPricewithoutCharge] = useState(0);
    const [accommodationPrice, setAccommodationPrice] = useState(0);
    const [paymentOptions, setPaymentOptions] = useState([])

    //console.log("84", tour_names);

    useEffect(() => {
        getTourDetail();
        // getTourByTourId(params.tour_Enrollment_id);
        // getImagesByTourId(params.tour_Enrollment_id);
        getAllTourList();
    }, [params.tour_Enrollment_id]);

    const getAllTourList = () => {
        axios.get(`${base_url.api1}/tourapp/trip_list?status=Active`, {}).then(
            (response) => {
                //console.log("100", response.data.tour);
                // setupcomingTourName(response.data.tour);
                document.getElementById("myForm").reset();
                // Find the object with matching id
                const matchingObject = response?.data?.tour?.find(
                    (obj) => obj.id == params?.tour_Enrollment_id
                );

                // Check if a matching object was found
                if (matchingObject) {
                    //console.log("Matching tour_names:", matchingObject.tour_names);
                    setupcomingTourName(matchingObject.tour_names);
                }
            },
            (error) => {
                setupcomingTourName(null);
                //console.log(JSON.stringify(error.response.data));
            }
        );
    };
    useEffect(() => {
        if (sameAsAbove) {
            console.log(country1)
            setValue("city2", originalCity);
            setValue("zip2", originalZip);
            setAddress2(address1);
            setregion2(region1);
            setcountry2(country1);

        }
    }, [
        sameAsAbove,
        originalCity,
        originalZip,
        address1,
        region1,
        country1,
        setValue,
    ]);
    const handleCheckboxChange = (e) => {
        setSameAsAbove(e.target.checked);
        if (!e.target.checked) {
            setValue("city2", "");
            setValue("zip2", "");
            setAddress2("");
            setregion2("");
            setcountry2("");
        }
    };

    const cardChargePercent = 0;
    const cardCharges = accommodation * (cardChargePercent / 100);

    const handleDepositeRequireChange = (e) => {
        const value = e.target.checked;

        const advance = Number(advancePayment);
        const deposit = Number(minimumDeposit);

        let newAdvance = 0;

        if (value) {
            newAdvance = advance + deposit;
        } else {
            newAdvance = advance - deposit;
        }

        // round only at the end (optional)
        setAdvancePayment(newAdvance.toFixed(2)); // string OK if UI needs it
        setDepositRequired(value);
    };

    const [extraDepositAmount, setExtraDepositAmount] = useState('')

    const handleExtraDepositCheck = (e) => {
        const value = e.target.checked;

        const advance = Number(advancePayment);
        const extraDeposit = Number(extraDepositAmount);

        let newAdvance = 0;

        if (value) {
            newAdvance = advance + extraDeposit;
        } else {

            newAdvance = advance - extraDeposit;
            setExtraDepositAmount('');
        }

        // round only at the end (optional)
        setAdvancePayment(newAdvance.toFixed(2)); // string OK if UI needs it
        setEnableExtraDeposit(value);
    }
    const handleAmountChange = (e) => {
        let value = e.target.value;

        value = value.replace(/[^0-9.]/g, "");

        const decimalIndex = value.indexOf(".");
        if (decimalIndex !== -1) {
            value =
                value.substring(0, decimalIndex + 1) +
                value.substring(decimalIndex + 1).replace(/\./g, "");
        }



        const extraPayment = Number(value);
        const minimumDepositAmount = Number(minimumDeposit);

        let newAdvance = 0;


        if (depositRequired) {

            newAdvance = minimumDepositAmount + extraPayment;
        } else {
            newAdvance = extraPayment;
        }


        // round only at the end (optional)
        setAdvancePayment(newAdvance.toFixed(2));





        setExtraDepositAmount(value);
    };

    const paymentMethodChange = (event) => {
        setPaymentMethod(event.target.value);

        // if (event.target.value === "Card") {
        //   if (selectedOptions.accommodation) {
        //     const newTotal = totalPricewithoutCharge + cardCharges;
        //     setTotalPrice(newTotal);
        //   }

        //   let newadvance = 0;

        //   newadvance += selectedCardOptions.fullPackage ? fullPackage : 0;
        //   newadvance += selectedCardOptions.insurance ? insurancePrice : 0;
        //   newadvance += selectedCardOptions.otherCost ? otherCost : 0;
        //   newadvance += selectedCardOptions.accommodation ? accommodationPrice : 0;

        //   setAdvancePayment(Number(newadvance).toFixed(2));
        // } else {
        //   setTotalPrice(totalPricewithoutCharge);
        //   setAdvancePayment(Number(totalPricewithoutCharge).toFixed(2));
        // }
    };

    // const handleRadioChange = (option) => {
    //   let newTotal = 0;
    //   // let newMinAdvance = 0;
    //   const newSelectedOptions = {
    //     ...selectedOptions,
    //     [option]: !selectedOptions[option],
    //   };

    //   newTotal += newSelectedOptions.fullPackage ? (fullPackage + accommodation) : 0;
    //   newTotal += newSelectedOptions.insurance ? insurancePrice : 0;
    //   newTotal += newSelectedOptions.singleRoomCost ? singleRoomCost : 0;
    //   // newMinAdvance += newTotal;

    //   newTotal += newSelectedOptions.accommodation ? accommodation : 0;
    //   // newMinAdvance += newSelectedOptions.accommodation ? 500 : 0;

    //   settotalPricewithoutCharge(newTotal);

    //   if (newSelectedOptions.accommodation == true && paymentMethod == "Card") {
    //     newTotal += cardCharges;
    //     setAccommodationPrice(accommodation + cardCharges);
    //   }

    //   // const depositEnabled = Object.keys(newSelectedOptions).some(
    //   //   (key) =>
    //   //     newSelectedOptions[key] == true && selectedCardOptions[key] != true
    //   // );

    //   // setDepositDisabled(!depositEnabled);
    //   // setminAdvance(newMinAdvance);

    //   setTotalPrice(newTotal);

    //   setSelectedOptions(newSelectedOptions);
    //   if (
    //     newSelectedOptions[option] == false &&
    //     selectedCardOptions[option] == true
    //   ) {
    //     handleCardRadioChange(option, newSelectedOptions);
    //   }
    // };

    // useEffect(() => {
    //   if (selectedOptions.fullPackage && ticketInDeposit) {
    //     setMinimumDeposit(totalMinimumDeposit);
    //     setDeposit(totalMinimumDeposit);
    //   } else if (selectedOptions.insurance && insuranceInDeposit) {
    //     setMinimumDeposit(totalMinimumDeposit);
    //     setDeposit(totalMinimumDeposit);
    //   } else if (selectedOptions.accommodation && accommodationInDeposit) {
    //     setMinimumDeposit(totalMinimumDeposit);
    //     setDeposit(totalMinimumDeposit);
    //   }else if (selectedOptions.singleRoomCost && singleRoomCostInDeposit) {
    //     setMinimumDeposit(totalMinimumDeposit);
    //     setDeposit(totalMinimumDeposit);
    //   } 

    //   else {
    //     setMinimumDeposit(otherAmount);
    //     setDeposit(otherAmount);
    //   }
    // }, [selectedOptions]);



    const handleRadioChange = (option) => {
        let newTotal = 0;

        let newSelectedOptions = {
            ...selectedOptions,
            [option]: !selectedOptions[option],
        };

        // 🔥 Mutual exclusivity logic
        if (option === "fullPackage" && newSelectedOptions.fullPackage) {
            newSelectedOptions.accommodation = false;
        }

        if (option === "accommodation" && newSelectedOptions.accommodation) {
            newSelectedOptions.fullPackage = false;
        }

        // 🔢 Price calculation
        if (newSelectedOptions.fullPackage) {
            newTotal += fullPackage;
        }

        if (newSelectedOptions.accommodation) {
            newTotal += accommodation;
        }

        if (newSelectedOptions.insurance) {
            newTotal += insurancePrice;
        }

        if (newSelectedOptions.otherCost) {
            newTotal += otherCost;
        }

        if (newSelectedOptions.singleRoomCost) {
            newTotal += singleRoomCost;
        }

        settotalPricewithoutCharge(newTotal);

        // 💳 Card charges only for accommodation
        if (newSelectedOptions.accommodation && paymentMethod === "Card") {
            newTotal += cardCharges;
            setAccommodationPrice(accommodation + cardCharges);
        } else {
            setAccommodationPrice(accommodation);
        }

        setTotalPrice(newTotal);
        setSelectedOptions(newSelectedOptions);

        // Handle card radio unselect
        if (
            newSelectedOptions[option] === false &&
            selectedCardOptions[option] === true
        ) {
            handleCardRadioChange(option, newSelectedOptions);
        }
    };

    // useEffect(() => {
    //   const value =
    //     (selectedOptions.fullPackage && ticketInDeposit) ||
    //       (selectedOptions.insurance && insuranceInDeposit) ||
    //       (selectedOptions.otherCost && otherCostInDeposit) ||
    //       (selectedOptions.accommodation && accommodationInDeposit) ||
    //       (selectedOptions.singleRoomCost && singleRoomCostInDeposit)
    //       ? totalMinimumDeposit
    //       : otherAmount;

    //   setMinimumDeposit(value);
    //   setDeposit(Number(value).toFixed(2));

    //   if (Object.values(selectedOptions).includes(true)) {
    //     handleDepositRadioChange(true)
    //   } else {
    //     handleDepositRadioChange(false)
    //   }
    // }, [selectedOptions, paymentMethod]);


    // useEffect(() => {
    //   if (selectedCardOptions.deposit) {
    //     let newAdvance = advancePayment;
    //     if (
    //       selectedOptions.fullPackage &&
    //       selectedCardOptions.fullPackage &&
    //       ticketInDeposit
    //     ) {
    //       newAdvance -= fullPackage;
    //     }

    //     if (
    //       selectedOptions.accommodation &&
    //       selectedCardOptions.accommodation &&
    //       accommodationInDeposit
    //     ) {
    //       newAdvance -= accommodation;
    //     }

    //     if (
    //       selectedOptions.singleRoomCost &&
    //       selectedCardOptions.singleRoomCost &&
    //       singleRoomCostInDeposit
    //     ) {
    //       newAdvance -= singleRoomCost;
    //     }

    //     if (
    //       selectedOptions.insurance &&
    //       selectedCardOptions.insurance &&
    //       insuranceInDeposit
    //     ) {
    //       newAdvance -= insurancePrice;
    //     }

    //     if (
    //       selectedOptions.otherCost &&
    //       selectedCardOptions.otherCost &&
    //       otherCostInDeposit
    //     ) {
    //       newAdvance -= otherCost;
    //     }

    //     setAdvancePayment(Number(newAdvance).toFixed(2));
    //   }
    // }, [selectedCardOptions]);

    const handleDepositRadioChange = (
        flag
    ) => {
        let newAdvance = 0;

        const newSelectedCardOptions = {
            ...selectedCardOptions,
            'deposit': flag,
        };




        if (deposit !== "") {
            newAdvance += newSelectedCardOptions.deposit ? parseFloat(deposit) : 0;
        }


        // setDepositDisabled(!depositEnabled);
        // setDeposit(Number(newDeposit).toFixed(2));
        setAdvancePayment(Number(newAdvance).toFixed(2));
        setSelectedCardOptions(newSelectedCardOptions);
    };

    const handleCardRadioChange = (
        option,
        newSelectedOptions = selectedOptions
    ) => {
        let newAdvance = 0;
        let newDeposit = deposit;
        const newSelectedCardOptions = {
            ...selectedCardOptions,
            [option]: !selectedCardOptions[option],
        };

        newAdvance += newSelectedCardOptions.fullPackage ? fullPackage : 0;
        newAdvance += newSelectedCardOptions.insurance ? insurancePrice : 0;
        newAdvance += newSelectedCardOptions.accommodation ? accommodationPrice : 0;
        newAdvance += newSelectedCardOptions.singleRoomCost ? singleRoomCost : 0;

        // const depositEnabled = Object.keys(newSelectedOptions).some(
        //   (key) =>
        //     newSelectedOptions[key] == true && newSelectedCardOptions[key] != true
        // );

        // if (!depositEnabled) {
        //   newDeposit = 0;
        // }
        if (deposit !== "") {
            newAdvance += newSelectedCardOptions.deposit ? parseFloat(deposit) : 0;
        }
        console.log("Optiona", option);
        console.log("Ticket ", ticketInDeposit);

        // setDepositDisabled(!depositEnabled);
        // setDeposit(Number(newDeposit).toFixed(2));
        setAdvancePayment(Number(newAdvance).toFixed(2));
        setSelectedCardOptions(newSelectedCardOptions);
    };

    const handleMobileInputChange = (e) => {
        let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
        if (value.length > 10) {
            return;
        }
        setMobile(value);
    };

    const [tourNewName, setTourNewName] = useState(null)

    const getTourDetail = () => {
        setbackdropopen(true);
        axios
            .get(`${base_url.api1}/tourapp/get_trip?id=${params.tour_Enrollment_id}`)
            .then((response) => {
                const accommodation =
                    Number(response.data.Tour[0].accommodation_only_price) || 0;
                const cardCharges = accommodation * (cardChargePercent / 100);

                setTourNewName(response.data.Tour[0].tour_names)
                setTripData(response.data.Tour[0]);
                setFullPackage(Number(response.data.Tour[0].full_package_price) || 0);
                setInsurancePrice(Number(response.data.Tour[0].insurance_price) || 0);
                setOtherCost(Number(response.data.Tour[0].other_cost) || 0);
                setOtherCostDescription(response.data.Tour[0].other_cost_description);
                setSingleRoomCost(Number(response.data.Tour[0].single_room_cost) || 0);
                setDeposit(Number(response.data.Tour[0].other_amount_in_deposit) || 0);
                // setDepositRequired(response.data.Tour[0].minimum_deposit_mandatory);
                setMinimumDepositRequired(response.data.Tour[0].minimum_deposit_mandatory);
                // handleCardRadioChange(response.data.Tour[0].minimum_deposit_mandatory);

                // if (response.data.Tour[0].minimum_deposit_mandatory) {
                //     setAdvancePayment(Number(response.data.Tour[0]?.minimum_deposit).toFixed(2) || 0.00)
                // }

                setMinimumDeposit(
                    Number(response.data.Tour[0].other_amount_in_deposit) || 0
                );
                setTotalMinimumDeposit(
                    Number(response.data.Tour[0].minimum_deposit) || 0
                );

                setZelleAdvancePayment(Number(response.data.Tour[0]?.minimum_deposit).toFixed(2) || 0.00)
                setOtherAmount(
                    Number(response.data.Tour[0].other_amount_in_deposit) || 0
                );
                setAccommodationInDeposit(
                    response.data.Tour[0].accommodation_in_deposit
                );

                setSingleRoomCostInDeposit(
                    response.data.Tour[0].single_room_cost_in_deposit
                );
                setInsuranceInDeposit(response.data.Tour[0].insurance_in_deposit);
                setOtherCostInDeposit(response.data.Tour[0].other_cost_in_deposit);
                setTicketInDeposit(response.data.Tour[0].ticket_in_deposit);
                setAccommodation(accommodation);
                setAccommodationPrice(accommodation + cardCharges);

                if (response?.data?.Tour[0]?.payment_methods && response?.data?.Tour[0]?.payment_methods?.length > 0) {

                    setPaymentOptions(response.data.Tour[0].payment_methods ?? [])
                } else {
                    setPaymentOptions([
                        "Cash", "Card", "Check", "Zelle"


                    ])
                }

                setPaymentMethod(response?.data?.Tour[0]?.payment_methods?.[0] ?? "Cash")
                setValue('payment_method', response?.data?.Tour[0]?.payment_methods?.[0] ?? "Cash")

                if (response.data.Tour[0].tour_status === "Active") {
                    setIsPastTour(false);
                }

                setbackdropopen(false);
            })
            .catch((err) => {
                setbackdropopen(false);
            });
    };

    const getTourByTourId = (value1) => {
        setbackdropopen(true);
        axios
            .get(`${base_url.api1}/tourapp/get_tour?id=` + params.tour_Enrollment_id)
            .then(
                (response) => {
                    setTourTitle(response.data.Tour[0].tour_names);

                    // setTripData(response.data.Tour[0]);
                    let remaining_seats =
                        response.data.Tour[0].total_seats -
                        response.data.Tour[0].booked_seat;
                    setAirFarePrice(
                        response.data.Tour[0].with_airfare_price.match(/\d+/)[0]
                    );
                    if (response.data.Tour[0].with_out_airfare_price) {
                        setWithoutAirFarePrice(
                            response.data.Tour[0].with_out_airfare_price.match(/\d+/)[0]
                        );
                    }
                    setFinalParticipants(remaining_seats);
                    let remaining_obj = [];
                    for (let i = 1; i <= remaining_seats; i++) {
                        remaining_obj.push(i);
                    }
                    setTripSeatData(remaining_obj);
                    setTripSeatData2(remaining_obj);
                    // dispatch(getTour(response.data.Tour));
                    setbackdropopen(false);
                },
                (error) => {
                    // dispatch(getTour(null));
                    setTourTitle();
                    setbackdropopen(false);
                    //console.log(JSON.stringify(error));
                }
            );
    };

    // const handleChangeAir = (e) =>{
    //   let remaining_data = finalParticipants-e.target.value;
    //   let remaining_obj = [];
    //   for (let i = 1; i <= remaining_data; i++) {
    //     remaining_obj.push(i);
    //   }
    //   setTripSeatData2(remaining_obj);
    // }

    // const handleChangeNonAir = (e) =>{
    //   let remaining_data = finalParticipants-e.target.value;
    //   let remaining_obj = [];
    //   for (let i = 1; i <= remaining_data; i++) {
    //     remaining_obj.push(i);
    //   }
    //   setTripSeatData(remaining_obj);
    // }

    const [allYear, setAllYear] = useState();
    const getYear = () => {
        let year_obj = [];
        for (let i = 2000; i < 3000; i++) {
            year_obj.push(i);
        }
        setAllYear(year_obj);
    };

    const getImagesByTourId = (value1) => {
        setbackdropopen(true);
        axios
            .get(
                `${base_url.api1}/tourapp/get_image?tour=` + params.tour_Enrollment_id
            )
            .then(
                (response) => {
                    setImageData(response.data.Gallery);
                    setbackdropopen(false);
                },
                (error) => {
                    setImageData();
                    setbackdropopen(false);
                    //console.log(JSON.stringify(error));
                }
            );
    };

    //name formating function
    const formatName = (name) => {
        console.log(name);

        if (typeof name !== 'string' || !name.trim()) return "";

        return name.trim().charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    };

    const getAddressValue = (addr) =>
        typeof addr === 'object' ? addr?.label ?? '' : addr ?? '';

    const onSubmit = (data2) => {
        console.log(country1, country2, region2)
        if (!country1) {
            setcountryValid1(true);
            return;
        }
        if (!region1) {
            setregion1Valid(true);
            return;
        }

        if (minimumDepositRequired) {

            if (!depositRequired) {
                setMinimumDepositError(true);
                return
            }

        }
        if (!sameAsAbove && !country2 && data2.payment_method !== "Zelle" && (depositRequired || minimumDepositRequired || enableExtraDeposit)) {
            setcountryValid2(true);
            return;
        }
        if (!sameAsAbove && !region2 && data2.payment_method !== "Zelle" && (depositRequired || minimumDepositRequired || enableExtraDeposit)) {
            setregion2Valid(true);
            return;
        }
        data2.tour_id = params.tour_Enrollment_id;
        data2.trip_start_date = tripData?.duartion_start_date;
        data2.trip_end_date = tripData?.duartion_end_date;
        data2.mode_of_tour = modeOfTour;
        data2.number_of_participants_with_airfare = "1";
        // data2.total_price =
        //     airParticipants * airFarePrice + nonAirParticipants * airFarePrice;
        data2.intrested_tour = upcomingTourName;
        data2.nationality = country1;
        data2.enquiry_status = "Pending";
        data2.place_of_birth = country1;
        data2.state = region1;
        data2.user = 1;
        data2.date_of_birth = data2.date_of_birth
            ? moment(data2.date_of_birth).format("YYYY-MM-DDThh:mm:ss")
            : null;
        data2.passport_expiration_date = data2.passport_expiration_date ? moment(
            data2.passport_expiration_date
        ).format("YYYY-MM-DDThh:mm:ss") : null;
        data2.trip_start_date = moment(data2.trip_start_date).format(
            "YYYY-MM-DDThh:mm:ss"
        );
        data2.trip_end_date = moment(data2.trip_end_date).format(
            "YYYY-MM-DDThh:mm:ss"
        );

        // const full_package = selectedOptions.fullPackage;
        // const accommodation_only = selectedOptions.accommodation;

        const full_package = selectedOptions.fullPackage === true;

        // accommodation should be true if
        // either accommodation is selected OR full package is selected
        const accommodation_only =
            selectedOptions.accommodation === true;

        const insurance = selectedOptions.insurance;
        const single_room_cost_only = selectedOptions.singleRoomCost;
        const other_cost_included = selectedOptions.otherCost;
        const remarks = data2.remarks;

        const single_room_cost = singleRoomCost

        let card_holder_name = null;
        let card_expiry_month = null;
        let card_expiry_year = null;
        let card_number = null;
        let card_cvv = null;
        let card_error = false;
        if (data2.payment_method === "Card" && (minimumDepositRequired || depositRequired || enableExtraDeposit)) {
            if (!cardDetails.card_number) {
                setCardError("Card number is required");
                Swal.fire({
                    icon: "error",
                    title: "Missing Information",
                    text: "Card number is required",
                });
                card_error = true;
                return;
            }
            if (!cardDetails.card_expiry_year) {
                setCardError("Card expiry date is required");
                card_error = true;
                Swal.fire({
                    icon: "error",
                    title: "Missing Information",
                    text: "Card expiry date is required",
                });
                return;
            }
            if (!cardDetails.card_cvv) {
                card_error = true;
                Swal.fire({
                    icon: "error",
                    title: "Missing Information",
                    text: "Card CVV is required",
                });
                setCardError("Card CVV is required");
                return;
            }


            card_error = false;


            setCardError(null);

        }

        if (card_error) {
            return;
        }


        if (Number(advancePayment) > 0 && data2.payment_method === "Card") {
            card_holder_name = data2.card_holder_name;
            card_expiry_month = cardDetails.card_expiry_year
                ? cardDetails.card_expiry_year.substring(0, 2)
                : null;
            card_expiry_year = cardDetails.card_expiry_year
                ? cardDetails.card_expiry_year.substring(5, 7)
                : null;
            card_number = cardDetails.card_number;
            card_cvv = cardDetails.card_cvv;
        }

        let data = {
            tour_id: params.tour_Enrollment_id,
            trip_start_date: data2.trip_start_date,
            trip_end_date: data2.trip_end_date,
            mode_of_tour: data2.mode_of_tour,
            number_of_participants_with_airfare: "1",
            // total_price: Number(totalPrice),
            intrested_tour: upcomingTourName,
            nationality: data2.nationality,
            enquiry_status: data2.enquiry_status,
            place_of_birth: data2.place_of_birth,
            state: data2.state,
            user: data2.user,
            date_of_birth: data2.date_of_birth ? data2.date_of_birth : null,
            passport_expiration_date: data2.passport_expiration_date,
            trip_start_date: data2.trip_start_date,
            trip_end_date: data2.trip_end_date,
            first_name: formatName(data2.first_name),
            middle_name: formatName(data2.middle_name),
            last_name: formatName(data2.last_name),
            gender: data2.gender,
            email_address: data2.email_address,
            // phone_number: mobile,
            phone_number: data2.mobile_number,
            date_of_birth: data2.date_of_birth ? data2.date_of_birth : null,
            city: formatName(data2.city),
            address: formatName(
                typeof address1 === 'object'
                    ? address1?.label ?? ''
                    : address1 ?? ''
            ),
            zip: data2.zip,
            passport_number: data2.passport_number,
            payment_method: data2.payment_method,
            number_of_participants_with_out_airfare: "0",
            accommodation_only,
            single_room_cost_only,
            other_cost_included,
            full_package,
            insurance,
            remarks,
            single_room_cost,
            card_holder_name: formatName(card_holder_name),
            card_expiry_month: card_expiry_month,
            card_expiry_year: card_expiry_year,
            advance_payment: data2.payment_method === "Zelle" ? Number(zelleAdvancePayment) : data2.payment_method === "Card" ? Number(advancePayment) : null,
            billing_address: data2.payment_method !== "Zelle"
                ? formatName(sameAsAbove ? getAddressValue(address1) : getAddressValue(address2))
                : null,
            billing_city: data2.payment_method !== "Zelle" ? sameAsAbove ? formatName(data2.city) : formatName(data2.city2) : null,
            billing_state: data2.payment_method !== "Zelle" ? sameAsAbove ? region1 : region2 : null,
            billing_zip: data2.payment_method !== "Zelle" ? sameAsAbove ? data2.zip : data2.zip2 : null,
            billing_country: data2.payment_method !== "Zelle" ? sameAsAbove ? country1 : country2 : null,
            special_ticket_preference: data2.special_ticket_preference,
            special_ticket_price: null

        };
        let submitData = {
            data: data,
            card_number: card_number,
            card_cvv: card_cvv,
        };
        //console.log(data);
        formData.append("data", JSON.stringify(submitData));

        setbackdropopen(true);
        axios.post(`${base_url.api1}/tourapp/trip_enquiry`, formData).then(
            (response) => {
                console.log(101010, response)
                if (response.status === 200) {
                    setbackdropopen(false);
                    handleViewModal();
                    // Swal.fire({
                    //     position: "center",
                    //     icon: "success",
                    //     title: "Payment Successful",
                    //     showCloseButton: true,
                    //     showConfirmButton: false,
                    // });
                    navigate("/thank-you-page", {
                        // state: { isClaimed: 3, unique_no: mobile },
                        state: {
                            isClaimed: 3,
                            unique_no: data2.mobile_number,
                            message: response?.data?.message || response?.data?.success_message

                        },
                    });
                    document.getElementById("myForm").reset();
                    setcountry1("United States");
                    setregion1("New York");
                    setcountry2("United States");
                    setregion2("New York");
                } else {
                    setbackdropopen(false);
                    handleViewModal();

                    // if (response?.data?.error_message) {
                    //    Swal.fire({
                    //   position: "center",
                    //   icon: "error",
                    //   text:response?.data?.error_message,
                    //   title: response?.data?.message,
                    //   showCloseButton: true,
                    //   showConfirmButton: false,
                    // });
                    // } else {
                    navigate("/thank-you-page", {
                        state: {
                            isClaimed: 4,
                            // unique_no: mobile,
                            unique_no: data2.mobile_number,

                            message: response?.data?.error_message ?? response?.data?.message,
                        },
                    });
                    document.getElementById("myForm").reset();
                    setcountry1("United States");
                    setregion1("New York");
                    setcountry2("United States");
                    setregion2("New York");
                    // }


                }
            },
            (error) => {
                setbackdropopen(false);
                handleViewModal();
                if (error?.response?.status >= 400 && error?.response?.status < 500) {
                    Swal.fire({
                        icon: "error",
                        title: error?.response?.data?.message || "Oops...",
                        text: "Something went wrong!",
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            }
        );
    };

    const [cardDetails, setCardDetails] = useState({
        card_number: null,
        card_expiry_month: null,
        card_expiry_year: null,
        card_cvv: null,
    });

    const handleChangeCardNumber = (e) => {
        setCardDetails({
            ...cardDetails,
            card_number: e.target.value,
        });
    };
    //console.log(cardDetails);

    const handleChangeExpiryDate = (e) => {
        setCardDetails({
            ...cardDetails,
            card_expiry_year: e.target.value,
        });
    };

    const handleChangeCVC = (e) => {
        setCardDetails({
            ...cardDetails,
            card_cvv: e.target.value,
        });
    };
    const goBack = () => {
        navigate(-1);
    };

    const [isPersonalOpen, setIsPersonalOpen] = useState(true);

    const personalToggle = () => setIsPersonalOpen(!isPersonalOpen);

    const [isAddressOpen, setIsAddressOpen] = useState(false);

    const addressToggle = () => setIsAddressOpen(!isAddressOpen);

    const [isPaymentOpen, setIsPaymentOpen] = useState(false);

    const paymentToggle = () => setIsPaymentOpen(!isPaymentOpen);

    function getCurrentDate() {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
        const day = currentDate.getDate().toString().padStart(2, "0");
        return `${year}-${month}-${day}`;
    }



    const parseAddressComponents = (components = []) => {
        const result = { city: "", state: "", postalCode: "", country: "" };

        components.forEach((c) => {
            if (c.types.includes("locality")) {
                result.city = c.long_name;
            }
            if (!result.city && c.types.includes("sublocality_level_1")) {
                result.city = c.long_name;
            }
            if (!result.city && c.types.includes("administrative_area_level_2")) {
                result.city = c.long_name;
            }

            if (c.types.includes("administrative_area_level_1")) {
                result.state = c.long_name;
            }
            if (c.types.includes("postal_code")) {
                result.postalCode = c.long_name;
            }
            if (c.types.includes("country")) {
                result.country = c.long_name;
            }
        });

        return result;
    };


    const onPlaceSelect_JS = (val, main = true) => {


        if (!val) {
            // clear related fields
            if (main) {
                setValue("city", "");
                setValue("zip", "");
                setregion1(null);
                setcountry1(null)
            } else {
                setValue("city2", "");
                setValue("zip2", "");
                setregion2(null);
                setcountry2(null)
            }


            return;
        }

        // val.value might be a placeId or an object containing place_id
        let placeId = val

        if (!window.google || !placeId) {
            // Google script not loaded (or not available) — keep the label but we can't refine components
            console.warn("Google script not loaded or missing placeId — cannot get address components.");
            return;
        }

        const ps = new window.google.maps.places.PlacesService(document.createElement("div"));

        ps.getDetails({ placeId, fields: ["address_components", "formatted_address", "name"] }, (place, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
                const parsed = parseAddressComponents(place.address_components || []);

                if (main) {
                    setValue("city", parsed?.city || "");
                    setValue("zip", parsed?.postalCode || "");
                    setregion1(parsed?.state || "");
                    setcountry1(parsed?.country || "")
                } else {
                    setValue("city2", parsed?.city || "");
                    setValue("zip2", parsed?.postalCode || "");
                    setregion2(parsed?.state || "");
                    setcountry2(parsed?.country || "")
                }




            } else {
                console.error("getDetails failed:", status);
            }
        });
    };

    useEffect(() => {

        onPlaceSelect_JS(address1?.value, true)


    }, [address1])

    useEffect(() => {

        onPlaceSelect_JS(address2?.value, false)


    }, [address2])

    return (
        <div style={{ backgroundColor: "#F5F6FA" }}>
            <React.Fragment>
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={backdropopen}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Nav />
                {/* <div style={{ position: "relative", height: "25vh" }}>
          <img
            src={bannerbackground}
            alt="Header_Image"
            style={{ height: "100%", width: "100%" }}
          />
          <div className="overlaybg">
            <div style={{ postion: "absolute" }}>
              <h1
                style={{
                  width: "100%",
                  marginTop: "200px",
                  fontSize: "3.5rem",
                  textAlign: "center",
                  color: "#fff",
                  fontFamily: " Caveat,cursive",
                }}
              >
                {tourTitle ? tourTitle : null}
              </h1>
            </div>
          </div>
        </div> */}

                <div className="container">
                    <div
                        className="page-head d-flex justify-content-between pb-4 pt-4"
                        style={{ marginTop: "1.3rem" }}
                    >
                        <ul className="breadcrums">
                            <Link to="/" className="b-link">
                                Home
                            </Link>
                            <span className="s_span ">&raquo;</span>
                            <Link onClick={goBack} className="b-link">
                                Linsoa Tours
                            </Link>
                            <span className="s_span ">&raquo;</span>
                            <Link onClick={goBack} className="b-link">
                                {isPastTour ? "Past Tours" : "Upcoming Tours"}
                            </Link>

                            <span className="s_span ">&raquo;</span>
                            <Link to="#" className="b-link active">
                                Enrollment
                            </Link>
                        </ul>



                    </div>


                    {tourNewName && <h3 className="tour-name-new-enrollment">{tourNewName}</h3>}
                    <Row className="px-0" >


                        <Col lg={12} className="carosol_img">
                            <form

                                id="myForm"
                                onSubmit={handleSubmit(onSubmit)}
                                className="login_container mobile_tour_enrollment_form"
                            >
                                <p className="tour_head_text_4">Personal Details</p>
                                <hr style={{ width: "20%", margin: "0 0 -1em" }} />
                                <div className="row">
                                    <div className="col-md-3" style={{ marginTop: "25px" }}>
                                        <label>
                                            Last Name<span style={{ color: "red" }}>*</span>
                                        </label>
                                        <div style={{ position: "relative" }}>
                                            <input
                                                type="text"
                                                id="tlast"
                                                {...register("last_name", {
                                                    required: true,
                                                })}
                                                className="form-control"
                                                placeholder="Last Name"
                                            />
                                            <i className="fa fa-user-o designi" />
                                        </div>
                                        {errors.last_name && (
                                            <p className="errormessage">Last Name is Required</p>
                                        )}
                                    </div>
                                    <div className="col-md-3" style={{ marginTop: "25px" }}>
                                        <label>
                                            First Name<span style={{ color: "red" }}>*</span>
                                        </label>
                                        <div style={{ position: "relative" }}>
                                            <input
                                                className="form-control"
                                                placeholder="First Name"
                                                type="text"
                                                id="tfirst"
                                                {...register("first_name", {
                                                    required: true,
                                                })}
                                            />
                                            <i className="fa fa-user-o designi" />
                                        </div>
                                        {errors.first_name && (
                                            <p className="errormessage">First Name is Required</p>
                                        )}
                                    </div>
                                    <div className="col-md-3" style={{ marginTop: "25px" }}>
                                        <label>Middle Name:</label>
                                        <div style={{ position: "relative" }}>
                                            <input
                                                className="form-control"
                                                placeholder="Middle Name"
                                                type="text"
                                                id="tfirst"
                                                {...register("middle_name", {
                                                    required: false,
                                                })}
                                            />
                                            <i className="fa fa-user-o designi" />
                                        </div>
                                        {errors.middle_name && (
                                            <p className="errormessage">Middle Name is Required</p>
                                        )}
                                    </div>


                                    <div className="col-md-3" style={{ marginTop: "25px" }}>
                                        <label>
                                            Gender<span style={{ color: "red" }}>*</span>
                                        </label>
                                        <div style={{ position: "relative" }}>
                                            <select
                                                className="form-control"
                                                id="tgender"
                                                {...register("gender", {
                                                    required: true,
                                                })}
                                            >
                                                <option value="">-- Select --</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                                <option value="Other">Other</option>
                                            </select>
                                            <i className="fa fa-venus designi" />
                                        </div>
                                        {errors.gender && (
                                            <p className="errormessage">Gender is Required</p>
                                        )}
                                    </div>
                                    <div className="col-md-3" style={{ marginTop: "25px" }}>
                                        <label>
                                            Date Of Birth<span style={{ color: "red" }}></span>
                                        </label>
                                        <div style={{ position: "relative" }}>

                                            <Controller
                                                name={`date_of_birth`}
                                                control={control}
                                                defaultValue={''}
                                                rules={{
                                                    required: false,
                                                    validate: validateDateFormat,
                                                }}
                                                render={({ field }) => (
                                                    <NewDate
                                                        value={field.value ?? ''}
                                                        onChange={(value) => {
                                                            field.onChange(value);

                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* <input
                                                type="date"
                                                id="tdate"
                                                className="form-control"
                                                {...register("date_of_birth", {
                                                    required: false,
                                                })}
                                                placeholder="DOB"
                                            />
                                            <i className="fa fa-calendar designi" /> */}
                                        </div>
                                    </div>

                                    {/* <div className="col-md-3" style={{ marginTop: "25px" }}>
                                        <label>
                                            10-Digit TelePhone NO./Profile ID:
                                            <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <div style={{ position: "relative" }}>
                                            <input
                                                type="text"
                                                id="tcontact"
                                                className="form-control "
                                                value={mobile}
                                                onChange={handleMobileInputChange}
                                                placeholder="Contact"
                                                required
                                            />
                                            <i className="fa fa-phone designi" />
                                        </div>
                                    </div> */}


                                    <div className="col-md-3" style={{ marginTop: "25px" }}>
                                        <label>
                                            10-Digit TelePhone NO./Profile ID:
                                            <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <div style={{ position: "relative" }}>
                                            <input
                                                type="text"
                                                id="tcontact"
                                                className="form-control"
                                                placeholder="Contact"
                                                {...register("mobile_number", {
                                                    required: "Contact is required",
                                                    maxLength: {
                                                        value: 10,
                                                        message: "Cannot exceed 10 digits"
                                                    },
                                                    minLength: {
                                                        value: 10,
                                                        message: "Must be exactly 10 digits"
                                                    },
                                                    pattern: {
                                                        value: /^[0-9]*$/,
                                                        message: "Only numbers are allowed"
                                                    },
                                                    onChange: (e) => {
                                                        // This handles the numeric-only logic and length limit 
                                                        // inside the Hook Form flow
                                                        const value = e.target.value.replace(/\D/g, "");
                                                        if (value.length <= 10) {
                                                            e.target.value = value;
                                                        } else {
                                                            e.target.value = value.slice(0, 10);
                                                        }
                                                    }
                                                })}
                                            />
                                            <i className="fa fa-phone designi" />
                                        </div>
                                        {errors.mobile_number && (
                                            <p className="errormessage">{errors.mobile_number.message}</p>
                                        )}
                                    </div>
                                    <div className="col-md-3" style={{ marginTop: "25px" }}>
                                        <label>
                                            Email<span style={{ color: "red" }}>*</span>
                                        </label>
                                        <div style={{ position: "relative" }}>
                                            <input
                                                type="email"
                                                id="temail"
                                                className="form-control"
                                                {...register("email_address", {
                                                    required: true,
                                                    pattern:
                                                        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$/,
                                                })}
                                                placeholder="Email"
                                            />
                                            <i className="fa fa-envelope-o designi" />
                                        </div>
                                        {errors.email_address && (
                                            <p className="errormessage">Email is Required</p>
                                        )}
                                    </div>
                                    <div className="col-md-3" style={{ marginTop: "25px" }}>
                                        <label>
                                            Passport number
                                        </label>
                                        <div style={{ position: "relative" }}>
                                            <input
                                                type="text"
                                                id="tpassport"
                                                className="form-control underline-input"
                                                {...register("passport_number", {
                                                    required: false,
                                                })}
                                                placeholder="Passport Number"
                                            />
                                            <i className="fa fa-id-card designi" />
                                        </div>
                                        {errors.passport_number && (
                                            <p className="errormessage">Passport is Required</p>
                                        )}
                                    </div>

                                    <div className="col-md-3" style={{ marginTop: "25px" }}>
                                        <label>
                                            Passport Expiration Date
                                            {/* <span style={{ color: "red" }}>*</span> */}
                                        </label>
                                        <div style={{ position: "relative" }}>
                                            <Controller
                                                name={`passport_expiration_date`}
                                                control={control}
                                                defaultValue={''}
                                                rules={{
                                                    required: false,
                                                    validate: validateDateFormat,
                                                }}
                                                render={({ field }) => (
                                                    <NewDate
                                                        value={field.value ?? ''}
                                                        onChange={(value) => {
                                                            field.onChange(value);

                                                        }}
                                                        maxYear={2099}
                                                    />
                                                )}
                                            />
                                            {/* <input
                                                type="date"
                                                id="texpire"
                                                className="form-control underline-input"
                                                {...register("passport_expiration_date", {
                                                    required: false,
                                                })}
                                                placeholder="Passport Expiration Date"
                                                min={getCurrentDate()}
                                            />
                                            <i className="fa fa-calendar-times designi" /> */}
                                        </div>
                                        {errors.passport_expiration_date && (
                                            <p className="errormessage">
                                                Passport Expiry Date is Required
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <p className="tour_head_text_4">Address</p>
                                <hr style={{ width: "20%", margin: "0 0 -1em" }} />
                                <div className="row">
                                    <div className="col-md-3">
                                        <label>
                                            Address<span style={{ color: "red" }}></span>
                                        </label>
                                        <NewGoogleAddressInput
                                            googleAddress={address1.label}
                                            setGoogleAddress={setAddress1}
                                            isRequired={false}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label>
                                            City<span style={{ color: "red" }}>*</span>
                                        </label>
                                        <div style={{ position: "relative" }}>
                                            <input
                                                type="text"
                                                id="tcity"
                                                className="form-control underline-input"
                                                {...register("city", { required: true })}
                                                placeholder="City"
                                            />
                                            <i className="fas fa-building designi" />
                                        </div>
                                        {errors.city && (
                                            <p className="errormessage">City is Required</p>
                                        )}
                                    </div>
                                    <div className="col-md-3">
                                        <label>
                                            State<span style={{ color: "red" }}>*</span>
                                        </label>
                                        <div style={{ position: "relative" }}>
                                            <RegionDropdown
                                                className="countrydropdown2 form-control underline-input"
                                                defaultOptionLabel="- Select State -"
                                                id="tstate"
                                                country={country1}
                                                value={region1}
                                                onChange={(val) => {
                                                    setregion1(val);
                                                    setregion1Valid(false);
                                                }}
                                            />
                                            <i className="fa fa-map-marker designi" />
                                        </div>
                                        {region1Valid ? (
                                            <p className="errormessage">State is Required</p>
                                        ) : null}
                                    </div>
                                    <div className="col-md-3">
                                        <label>
                                            Zip Code.<span style={{ color: "red" }}>*</span>
                                        </label>
                                        <div style={{ position: "relative" }}>
                                            <input
                                                type="text"
                                                id="tzip"
                                                className="form-control underline-input"
                                                {...register("zip", { required: true })}
                                                placeholder="Zip Code"
                                                maxLength={6}
                                            />
                                            <i className="fa fa-tag designi" />
                                        </div>
                                        {errors.zip && (
                                            <p className="errormessage">Zip is Required</p>
                                        )}
                                    </div>
                                    <div className="col-md-3">
                                        <label>
                                            Country<span style={{ color: "red" }}>*</span>
                                        </label>
                                        <div style={{ position: "relative" }}>
                                            <CountryDropdown
                                                className="countrydropdown2 form-control underline-input"
                                                id="tcountry"
                                                defaultOptionLabel="- Select Country -"
                                                value={country1}
                                                onChange={(val) => {
                                                    setcountry1(val);
                                                    setregion1(null);
                                                    setcountryValid1(false);
                                                }}
                                            />
                                            <i className="fas fa-globe designi" />
                                        </div>
                                        {countryValid1 ? (
                                            <p className="errormessage">Country is Required</p>
                                        ) : null}
                                    </div>
                                </div>
                                <p className="tour_head_text_4">Cost and Payment</p>
                                <hr style={{ width: "20%" }} />


                                <div className="form-group creatadmin2">
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "flex-start",
                                            flexWrap: "nowrap",
                                            marginLeft: "35px",
                                            marginRight: "35px",
                                        }}
                                        className="mobile-checkbox"
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                whiteSpace: "nowrap",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                name="packageOption"
                                                id="fullPackage"
                                                {...register("fullPackage", {
                                                    required: !selectedOptions.accommodation,
                                                })}
                                                checked={selectedOptions.fullPackage}
                                                onChange={() => handleRadioChange("fullPackage")}
                                            />
                                            <label
                                                htmlFor="fullPackage"
                                                style={{ marginLeft: "8px" }}
                                            >
                                                Full Package <br /> (${Number(fullPackage)})
                                            </label>
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                whiteSpace: "nowrap",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                name="packageOption"
                                                id="accommodation"
                                                {...register("accommodation", {
                                                    required: !selectedOptions.fullPackage,
                                                })}
                                                checked={selectedOptions.accommodation}
                                                onChange={() => handleRadioChange("accommodation")}
                                            />
                                            <label
                                                htmlFor="accommodation"
                                                style={{ marginLeft: "8px" }}
                                            >
                                                Accommodations Only <br /> (${accommodation})
                                            </label>
                                        </div>


                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                whiteSpace: "nowrap",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                name="packageOption"
                                                id="singleRoomCost"

                                                checked={selectedOptions.singleRoomCost}
                                                onChange={() => handleRadioChange("singleRoomCost")}
                                            />
                                            <label
                                                htmlFor="singleRoomCost"
                                                style={{ marginLeft: "8px" }}
                                            >
                                                Private Room Cost <br /> (${singleRoomCost})
                                            </label>
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                whiteSpace: "nowrap",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                name="insuranceOption"
                                                id="insurance"
                                                checked={selectedOptions.insurance}
                                                onChange={() => handleRadioChange("insurance")}
                                            />
                                            <label htmlFor="insurance" style={{ marginLeft: "8px" }}>
                                                Travel Insurance <br /> (${insurancePrice})
                                            </label>
                                        </div>


                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                whiteSpace: "nowrap",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                name="otherCostOption"
                                                id="otherCost"
                                                checked={selectedOptions.otherCost}
                                                onChange={() => handleRadioChange("otherCost")}
                                            />
                                            <label htmlFor="otherCost" style={{ marginLeft: "8px" }}>
                                                Other Cost <br /> (${otherCost})
                                            </label>
                                        </div>




                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "10px",
                                            }}
                                            className="mobile-total-cost"
                                        >
                                            {/* {selectedOptions.fullPackage && paymentMethod == 'Card' && <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "10px",
                        }}>
                        <label>Ticket</label>
                        <div style={{ position: "relative" }}>
                          <input
                            type="number"
                            className="form-control underline-input"
                            value={Number(selectedOptions.fullPackage ? fullPackage : 0).toFixed(2)}
                            disabled
                          // style={{ width: "60%" }}
                          />
                         <i
                            className="fa fa-dollar designi"
                            style={{
                              fontSize: "10px"
                            }}
                          />
                        </div>
                      </div>} */}
                                            {/* {selectedOptions.accommodation && paymentMethod == 'Card' && <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "10px",
                        }}>
                        <label>Accommodation</label>
                        <div style={{ position: "relative" }}>
                          <input
                            type="text"
                            className="form-control underline-input"
                            // {...register("accommodation_payment", {
                            //   required: {
                            //     value: selectedOptions.accommodation,
                            //     message: "Accommodation is required"
                            //   },
                            //   min: {
                            //     value: 500,
                            //     message: `Minimum $500 Accommodation is required`,
                            //   }
                            // })}
                            value={selectedOptions.accommodation ? accommodationPrice : 0}
                            // onChange={handleAmountChange}
                            disabled
                          // style={{ width: "60%" }}
                          />
                          <i
                            className="fa fa-dollar designi"
                            style={{
                              fontSize: "10px"
                            }}
                          />
                          //{errors.accommodation_payment && (
                          //  <p className="errormessage">
                          //    {errors.accommodation_payment.message}
                          //  </p>
                          //)}
                        </div>
                      </div>} */}
                                            {/* {selectedOptions.insurance && paymentMethod == 'Card' && <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "10px",
                        }}>
                        <label>Insurance</label>
                        <div style={{ position: "relative" }}>
                          <input
                            type="number"
                            className="form-control underline-input"
                            value={Number(selectedOptions.insurance ? insurancePrice : 0).toFixed(2)}
                            disabled
                          // style={{ width: "60%" }}
                          />
                          <i
                            className="fa fa-dollar designi"
                            style={{
                              fontSize: "10px"
                            }}
                          />
                        </div>
                      </div>} */}

                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <label>Total Cost</label>
                                                <div style={{ position: "relative" }}>
                                                    <input
                                                        type="text"
                                                        className="form-control underline-input"
                                                        value={Number(totalPrice).toFixed(2)}
                                                        disabled
                                                    />
                                                    <i
                                                        className="fa fa-dollar designi"
                                                        style={{
                                                            fontSize: "10px",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {(errors.accommodation || errors.fullPackage) && (
                                        <p className="errormessage">
                                            Select one of Full Package or Accommodation
                                        </p>
                                    )}
                                </div>

                                {/* <div>


                                    <div className="radio-wrapper">



                                        <label style={{ marginBottom: '10px' }}>Special Ticket Arrangment</label>

                                        <Controller
                                            name="special_ticket_preference"
                                            control={control}
                                            render={({ field }) => (
                                                <div className="radio-row">
                                                    {options.map((item) => (
                                                        <label
                                                            key={item.value}
                                                            style={{ display: 'flex', alignItems: 'center', gap: "10px" }}
                                                        >
                                                            <input
                                                                type="radio"
                                                                value={item.value}
                                                                checked={field.value === item.value}
                                                                onChange={() => field.onChange(item.value)}
                                                            />


                                                            <span style={{ fontWeight: 400, color: "#222", whiteSpace: 'nowrap', fontSize: '16px' }}>{item.label}</span>
                                                        </label>
                                                    ))}
                                                </div>
                                            )}
                                        />





                                    </div>
                                </div> */}


                                <div>
                                    <div className="radio-wrapper">
                                        <label style={{ marginBottom: '10px' }}>Special Ticket Arrangement (Not the group tickets)</label>

                                        <Controller
                                            name="special_ticket_preference"
                                            control={control}
                                            render={({ field }) => (
                                                <div className="radio-row" style={{ display: 'flex', gap: '20px' }}>
                                                    {options.map((item) => (
                                                        <label
                                                            key={item.value}
                                                            style={{ display: 'flex', alignItems: 'center', gap: "10px", cursor: 'pointer' }}
                                                        >
                                                            <input
                                                                type="checkbox" // Changed to checkbox for easier unselecting
                                                                value={item.value}
                                                                // Matches if this specific checkbox is the current form value
                                                                checked={field.value === item.value}
                                                                onChange={() => {
                                                                    // If clicking the one already selected, set to null (unselect)
                                                                    // Otherwise, update to the new value
                                                                    const newValue = field.value === item.value ? null : item.value;
                                                                    field.onChange(newValue);
                                                                }}
                                                            />
                                                            <span style={{ fontWeight: 400, color: "#222", whiteSpace: 'nowrap', fontSize: '16px' }}>
                                                                {item.label}
                                                            </span>
                                                        </label>
                                                    ))}
                                                </div>
                                            )}
                                        />
                                    </div>
                                </div>

                                {
                                    otherCostDescription && <p className="tour-note" style={{ fontSize: "15px", marginBottom: '30px' }}>

                                        {otherCostDescription}
                                    </p>
                                }
                                {paymentMethod == "Card" && (
                                    <div
                                        className="form-group createadmin "
                                        style={{ margin: "0 20px" }}
                                    >
                                        {/* {selectedOptions.fullPackage && (
                                            <div className="row" style={{ padding: "0 1em" }}>
                                                <div className="col-md-3">
                                                <input
                                                    style={{ width: "auto" }}
                                                    type="checkbox"
                                                    name="packageOption"
                                                    id="cardfullPackage"
                                                    checked={selectedCardOptions.fullPackage}
                                                    onChange={() =>
                                                    handleCardRadioChange("fullPackage")
                                                    }
                                                />
                                                <label
                                                    htmlFor="cardfullPackage"
                                                    style={{ marginLeft: "8px" }}
                                                >
                                                    Ticket <br /> (${fullPackage})
                                                </label>
                                                </div>
                                                <div className="col-md-3">
                                                <label>Ticket</label>
                                                <div style={{ position: "relative" }}>
                                                    <input
                                                    type="number"
                                                    className="form-control underline-input"
                                                    value={Number(fullPackage).toFixed(2)}
                                                    disabled
                                                    />
                                                    <i
                                                    className="fa fa-dollar designi"
                                                    style={{
                                                        fontSize: "10px",
                                                    }}
                                                    />
                                                </div>
                                                </div>
                                            </div>
                                            )}

                                            {selectedOptions.accommodation && (
                                            <div className="row" style={{ padding: "0 1em" }}>
                                                <div className="col-md-3">
                                                <input
                                                    style={{ width: "auto" }}
                                                    type="checkbox"
                                                    name="packageOption"
                                                    id="cardaccommodation"
                                                    checked={selectedCardOptions.accommodation}
                                                    onChange={() =>
                                                    handleCardRadioChange("accommodation")
                                                    }
                                                />
                                                <label
                                                    htmlFor="cardaccommodation"
                                                    style={{ marginLeft: "8px" }}
                                                >
                                                    Accommodation <br /> (${accommodationPrice})
                                                </label>
                                                </div>
                                                <div className="col-md-3">
                                                <label>Accommodation</label>
                                                <div style={{ position: "relative" }}>
                                                    <input
                                                    type="number"
                                                    className="form-control underline-input"
                                                    value={Number(accommodationPrice).toFixed(2)}
                                                    disabled
                                                    />
                                                    <i
                                                    className="fa fa-dollar designi"
                                                    style={{ fontSize: "10px" }}
                                                    />
                                                </div>
                                                </div>
                                            </div>
                                            )}

                                            {selectedOptions.singleRoomCost && (
                                            <div className="row" style={{ padding: "0 1em" }}>
                                                <div className="col-md-3">
                                                <input
                                                    style={{ width: "auto" }}
                                                    type="checkbox"
                                                    name="packageOption"
                                                    id="cardsingleRoomCost"
                                                    checked={selectedCardOptions.singleRoomCost}
                                                    onChange={() =>
                                                    handleCardRadioChange("singleRoomCost")
                                                    }
                                                />
                                                <label
                                                    htmlFor="cardsingleRoomCost"
                                                    style={{ marginLeft: "8px" }}
                                                >
                                                    Single Room Cost <br /> (${singleRoomCost})
                                                </label>
                                                </div>
                                                <div className="col-md-3">
                                                <label>Single Room Cost</label>
                                                <div style={{ position: "relative" }}>
                                                    <input
                                                    type="number"
                                                    className="form-control underline-input"
                                                    value={Number(singleRoomCost).toFixed(2)}
                                                    disabled
                                                    />
                                                    <i
                                                    className="fa fa-dollar designi"
                                                    style={{ fontSize: "10px" }}
                                                    />
                                                </div>
                                                </div>
                                            </div>
                                            )}

                                            {selectedOptions.insurance && (
                                            <div className="row" style={{ padding: "0 1em" }}>
                                                <div className="col-md-3">
                                                <input
                                                    style={{ width: "auto" }}
                                                    type="checkbox"
                                                    name="insuranceOption"
                                                    id="cardinsurance"
                                                    checked={selectedCardOptions.insurance}
                                                    onChange={() => handleCardRadioChange("insurance")}
                                                />
                                                <label
                                                    htmlFor="cardinsurance"
                                                    style={{ marginLeft: "8px" }}
                                                >
                                                    Travel Insurance <br /> (${insurancePrice})
                                                </label>
                                                </div>
                                                <div className="col-md-3">
                                                <label>Travel Insurance</label>
                                                <div style={{ position: "relative" }}>
                                                    <input
                                                    type="number"
                                                    className="form-control underline-input"
                                                    value={Number(insurancePrice).toFixed(2)}
                                                    disabled
                                                    />
                                                    <i
                                                    className="fa fa-dollar designi"
                                                    style={{ fontSize: "10px" }}
                                                    />
                                                </div>
                                                </div>
                                            </div>
                                            )} */}

                                        {(selectedOptions.fullPackage ||
                                            selectedOptions.accommodation || selectedOptions.singleRoomCost ||
                                            selectedOptions.insurance) && (
                                                <div className="row" style={{ padding: "0 1em" }}>
                                                    <div className="col-md-3">
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                            <input
                                                                style={{ width: "auto" }}
                                                                type="checkbox"

                                                                id="carddeposit"

                                                                checked={depositRequired}
                                                                onChange={handleDepositeRequireChange}
                                                            />
                                                            <label
                                                                htmlFor="carddeposit"
                                                                style={{ marginLeft: "8px" }}
                                                            >
                                                                Deposit {minimumDepositRequired && '(Mandatory)'} <br /> (Minimum ${minimumDeposit})
                                                            </label>
                                                        </div>

                                                        {minimumDepositError && (
                                                            <p className="errormessage">
                                                                Minimum Deposit is Required
                                                            </p>
                                                        )}

                                                    </div>
                                                    <div className="col-md-3">
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                            <input
                                                                style={{ width: "auto" }}
                                                                type="checkbox"


                                                                checked={enableExtraDeposit}
                                                                onChange={(e) => {

                                                                    // setEnableExtraDeposit(e.target.checked);
                                                                    handleExtraDepositCheck(e)


                                                                }}
                                                            />
                                                            <div>

                                                                <label>Payment</label>
                                                                <div style={{ position: "relative" }}>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control underline-input"

                                                                        value={extraDepositAmount}
                                                                        onChange={handleAmountChange}

                                                                        readOnly={!enableExtraDeposit}

                                                                    />
                                                                    <i
                                                                        className="fa fa-dollar designi"
                                                                        style={{ fontSize: "10px" }}
                                                                    />
                                                                </div>
                                                            </div>

                                                        </div>

                                                        {errors.deposit_payment && (
                                                            <p className="errormessage">
                                                                {errors.deposit_payment.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                    </div>
                                )}
                                <div className="form-group creatadmin2">
                                    <div className="row">
                                        {/* Payment Method - always visible */}
                                        <div
                                            style={{
                                                width: paymentMethod === "Card" ? "23%" : "23%",
                                            }}
                                            className="mobile-payment-method"
                                        >
                                            <label>
                                                Payment Method
                                                <span style={{ color: "red" }}>*</span>:
                                            </label>
                                            <select
                                                className="form-control"
                                                {...register("payment_method", { required: true })}
                                                defaultValue={paymentMethod}
                                                onChange={paymentMethodChange}
                                            >
                                                {
                                                    paymentOptions.map((option, index) => <option value={option} key={index}>{option}</option>)
                                                }
                                            </select>
                                            <i className="fa fa-google-wallet designi" />
                                            {errors.payment_method && (
                                                <p className="errormessage">
                                                    Payment Method is Required
                                                </p>
                                            )}
                                        </div>



                                        {
                                            paymentMethod === "Zelle" && (<div
                                                style={{ width: "15%" }}
                                                className="mobile_card_payment"
                                            >
                                                <label>Payment</label>
                                                <div style={{ position: "relative" }}>
                                                    <input
                                                        type="text"
                                                        className="form-control underline-input"

                                                        value={zelleAdvancePayment}
                                                        onChange={(e) => {
                                                            const value = e.target.value;

                                                            // Allow only numbers and one dot
                                                            const regex = /^\d*\.?\d*$/;

                                                            if (regex.test(value)) {
                                                                setZelleAdvancePayment(value);
                                                            }
                                                        }}

                                                    />
                                                    <i className="fa fa-dollar designi" />

                                                </div>
                                            </div>)
                                        }

                                        {/* Conditional rendering for Card payment method */}
                                        {paymentMethod === "Card" && (
                                            <>
                                                <div
                                                    style={{ width: "15%" }}
                                                    className="mobile_card_payment"
                                                >
                                                    <label>Payment</label>
                                                    <div style={{ position: "relative" }}>
                                                        <input
                                                            type="text"
                                                            className="form-control underline-input"
                                                            {...register("advance_payment", {
                                                                min: {
                                                                    value: 500,
                                                                    message: `Minimum $${500} payment is required`,
                                                                },
                                                            })}
                                                            value={Number(advancePayment).toFixed(2)}
                                                            disabled
                                                        // style={{ width: "60%" }}
                                                        />
                                                        <i className="fa fa-dollar designi" />
                                                        {errors.advance_payment && (
                                                            <p className="errormessage">
                                                                {errors.advance_payment.message}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                                <div
                                                    style={{ width: "20%" }}
                                                    className="mobile_card_payment"
                                                >
                                                    <label>
                                                        Card Holder Name{(enableExtraDeposit || depositRequired) && <span style={{ color: "red" }}>*</span>}:
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control underline-input"
                                                        {...register("card_holder_name", {
                                                            required: (depositRequired || enableExtraDeposit),
                                                        })}
                                                    />
                                                    <i className="fa fa-user designi" />
                                                    {errors.card_holder_name && (
                                                        <p className="errormessage">
                                                            Card Holder Name is Required
                                                        </p>
                                                    )}
                                                </div>

                                                <div
                                                    style={{ width: "38%", marginTop: "22px" }}
                                                    className="mobile_card_payment"
                                                >
                                                    <PaymentInputsWrapper {...wrapperProps}>
                                                        <svg {...getCardImageProps({ images })} />
                                                        <input
                                                            {...getCardNumberProps({
                                                                onChange: handleChangeCardNumber,
                                                            })}
                                                        />
                                                        <input
                                                            {...getExpiryDateProps({
                                                                onChange: handleChangeExpiryDate,
                                                            })}
                                                        />
                                                        <input
                                                            {...getCVCProps({ onChange: handleChangeCVC })}
                                                        />
                                                    </PaymentInputsWrapper>

                                                    {
                                                        cardError &&
                                                        <div className="errormessage" style={{ width: "100%" }}>
                                                            {cardError}
                                                        </div>

                                                    }
                                                </div>

                                                {/* <div className="errormessage" style={{ width: "100%", marginTop: "20px" }}>
                          Merchant service temporary down, please call the office at <a href="tel:8453881104"><strong>845-388-1104</strong></a> to process your credit card payment

                        </div> */}

                                                <div className="errormessage" style={{ width: "100%", marginTop: "20px" }}>
                                                    3 percent credit card processing fee will be added (Does not apply to mandatory min. deposit amount and the Insurance cost)

                                                </div>
                                                {/* <div className="errormessage" style={{ width: "100%" }}>
                          (Does not apply for the Deposit, ticket and Insurance cost)

                        </div> */}

                                            </>
                                        )}
                                    </div>

                                    {paymentMethod === "Zelle" && (
                                        <label style={{ marginTop: "28px" }}>
                                            to: Herman@linsoatours.com
                                        </label>
                                    )}
                                </div>
                                {
                                    paymentMethod !== "Zelle" && (depositRequired || enableExtraDeposit) && <>
                                        <p className="tour_head_text_4" style={{ marginTop: "1em" }}>
                                            Billing Address
                                        </p>
                                        <hr style={{ width: "20%" }} />
                                        <div className="form-group creatadmin2">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="sameAsAbove"
                                                    checked={sameAsAbove}
                                                    onChange={handleCheckboxChange}
                                                    style={{ marginLeft: "10px", marginRight: "5px" }}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="sameAsAbove"
                                                    style={{ marginTop: "8px" }}
                                                >
                                                    Same as above Address
                                                </label>
                                            </div>
                                            {
                                                !sameAsAbove && <div className="row">
                                                    <div className="col-md-3">
                                                        <label>
                                                            Address<span style={{ color: "red" }}></span>
                                                        </label>
                                                        <NewGoogleAddressInput
                                                            googleAddress={address2.label}
                                                            setGoogleAddress={setAddress2}
                                                            isRequired={false}
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label>
                                                            City{(enableExtraDeposit || depositRequired) && <span style={{ color: "red" }}>*</span>}
                                                        </label>
                                                        <div style={{ position: "relative" }}>
                                                            <input
                                                                type="text"
                                                                id="tcity"
                                                                className="form-control underline-input"
                                                                {...register("city2", { required: (enableExtraDeposit || depositRequired) })}
                                                                placeholder="City"
                                                            />
                                                            <i className="fas fa-building designi" />
                                                        </div>
                                                        {errors.city2 && (
                                                            <p className="errormessage">City is Required</p>
                                                        )}
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label>
                                                            State{(enableExtraDeposit || depositRequired) && <span style={{ color: "red" }}>*</span>}
                                                        </label>
                                                        <div style={{ position: "relative" }}>
                                                            <RegionDropdown
                                                                className="countrydropdown2 form-control underline-input"
                                                                defaultOptionLabel="- Select State -"
                                                                id="tstate"
                                                                country={country2}
                                                                value={region2}
                                                                onChange={(val) => {
                                                                    setregion2(val);
                                                                    setregion2Valid(false);
                                                                }}
                                                            />
                                                            <i className="fa fa-map-marker designi" />
                                                        </div>
                                                        {region2Valid ? (
                                                            <p className="errormessage">State is Required</p>
                                                        ) : null}
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label>
                                                            Zip Code.{(enableExtraDeposit || depositRequired) && <span style={{ color: "red" }}>*</span>}
                                                        </label>
                                                        <div style={{ position: "relative" }}>
                                                            <input
                                                                type="text"
                                                                id="tzip"
                                                                className="form-control underline-input"
                                                                {...register("zip2", { required: (enableExtraDeposit || depositRequired) })}
                                                                placeholder="Zip Code"
                                                                maxLength={6}
                                                            />
                                                            <i className="fa fa-tag designi" />
                                                        </div>
                                                        {errors.zip2 && (
                                                            <p className="errormessage">Zip is Required</p>
                                                        )}
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label>
                                                            Country{(enableExtraDeposit || depositRequired) && <span style={{ color: "red" }}>*</span>}
                                                        </label>
                                                        <div style={{ position: "relative" }}>
                                                            <CountryDropdown
                                                                className="countrydropdown2 form-control underline-input"
                                                                id="tcountry"
                                                                defaultOptionLabel="- Select Country -"
                                                                value={country2}
                                                                onChange={(val) => {
                                                                    setcountry2(val);
                                                                    setregion2(null);

                                                                    setcountryValid2(false);
                                                                }}
                                                            />
                                                            <i className="fas fa-globe designi" />
                                                        </div>
                                                        {countryValid2 ? (
                                                            <p className="errormessage">Country is Required</p>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            }

                                        </div>

                                    </>
                                }

                                <Row>
                                    <Col md={3}></Col>
                                    <div className="col-md-6">
                                        <label>Remark</label>
                                        <div style={{ position: "relative" }}>
                                            <textarea
                                                type="text"
                                                id="note"
                                                {...register("remarks", {
                                                    required: false,
                                                })}
                                                style={{
                                                    minHeight: "150px",
                                                    fontSize: "18px",
                                                }}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    <Col md={3}></Col>
                                </Row>

                                <div
                                    style={{ padding: "0 20px ", marginBottom: "50px" }}
                                    className="mobile-submit-button-wrapper"
                                >
                                    <div>
                                        <div
                                            style={{
                                                float: "right",
                                                display: "flex",
                                                padding: "5px",
                                            }}
                                            className="mobile-submit-button-group"
                                        >
                                            <Button
                                                style={{
                                                    padding: "10px 45px",
                                                    marginLeft: "5px",
                                                    float: "right",
                                                    borderRadius: "40px",
                                                }}
                                                color="primary"
                                                onClick={handleViewModal}
                                            >
                                                Reset
                                            </Button>
                                            <Button
                                                type="submit"
                                                style={{
                                                    padding: "10px 40px",
                                                    marginLeft: "5px",
                                                    float: "right",
                                                    borderRadius: "40px",
                                                }}
                                                color="primary"
                                            >
                                                Submit
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </Col>
                    </Row>

                    <div className="tourdetails_grid"></div>
                </div>

                <FooterNew />
            </React.Fragment>
        </div>
    );
};

export default TourTripEnrollmentCopy1;
